<mat-stepper  [orientation]="isHandset ? 'vertical' : 'horizontal'" linear #stepper>

  <!-- Step 1: Osnovni podaci o općini -->
  <mat-step [stepControl]="municipalityBasicInfoForm">
    <ng-template matStepLabel>I. Osnovni podaci o Općini</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">I. Osnovni podaci o Općini</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="municipalityBasicInfoForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Naziv Općine</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Telefon</mat-label>
              <input matInput formControlName="telephone" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Mobitel</mat-label>
              <input matInput formControlName="mobile"  />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Administratori u Općini</mat-label>
              <mat-select formControlName="users" multiple>
                @for (user of users; track user) {
                  <mat-option [value]="user.id">
                    {{ user.userName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <button mat-flat-button matStepperNext class="daxa" [disabled]="municipalityBasicInfoForm.invalid">Dalje</button>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2 (if updating): Potvrda -->
  <mat-step>
    <ng-template matStepLabel>Potvrda</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">Ažuriranje podataka o Općini</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div>
          <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
          <button mat-flat-button color="primary" (click)="onSubmit()">Spremi</button>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-step>

</mat-stepper>